import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {setDeleteMachineId, setUpdateMachineId} from "../../actions/machine";
import {Link} from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faEye } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'react-bootstrap';
import { usePermission } from '../../hooks/usePermission';

const MachineItem = ({
                           setDeleteMachineId,
                           setUpdateMachineId,
                           machine: {
                               id, name, model, serial_number, status,
                               operator,
                               firm
                           },
                           number
                       }) => {
    const { userCan } = usePermission();

    if (!userCan('browse machines')) {
        return null;
    }

    const setDeleteMachine = (id) => {
        setDeleteMachineId(id);
    };

    const setUpdateMachine = (id) => {
        setUpdateMachineId(id);
    };

    const getStatusBadge = (status) => {
        const statusClasses = {
            'active': 'badge bg-success',
            'maintenance': 'badge bg-warning text-dark',
            'inactive': 'badge bg-secondary'
        };
        
        const statusTexts = {
            'active': 'Faol',
            'maintenance': 'Ta\'mirlash',
            'inactive': 'Nofaol'
        };

        return (
            <span className={statusClasses[status] || 'badge bg-secondary'}>
                {statusTexts[status] || status}
            </span>
        );
    };

    return (
        <Fragment>
            <tr>
                <th scope="row">{number}</th>
                <td>{name}</td>
                <td>{model || '-'}</td>
                <td>{serial_number || '-'}</td>
                <td>
                    {userCan('view firms') && firm?.id ? (
                        <Link to={`/firms/${firm.id}`}>
                            {firm.name}
                        </Link>
                    ) : (
                        firm?.name || '-'
                    )}
                </td>
                <td>
                    {operator ? (
                        `${operator?.first_name || ''}  ${operator?.last_name || ''}`
                    ) : (
                        '-'
                    )}
                </td>
                <td>{getStatusBadge(status)}</td>
                <td>
                    <div className="d-flex gap-2">
                        {userCan('read machines') && (
                            <Link to={`/machines/${id}`}>
                                <Button
                                    variant="outline-secondary"
                                    size="sm"
                                    className="d-flex align-items-center justify-content-center"
                                    style={{ width: '32px', height: '32px', padding: 0 }}
                                >
                                    <FontAwesomeIcon icon={faEye} />
                                </Button>
                            </Link>
                        )}
                        {userCan('edit machines') && (
                            <Button
                                variant="outline-primary"
                                size="sm"
                                className="d-flex align-items-center justify-content-center"
                                style={{ width: '32px', height: '32px', padding: 0 }}
                                onClick={() => setUpdateMachine(id)}
                            >
                                <FontAwesomeIcon icon={faEdit} />
                            </Button>
                        )}
                        {userCan('delete machines') && (
                            <Button
                                variant="outline-danger"
                                size="sm"
                                className="d-flex align-items-center justify-content-center"
                                style={{ width: '32px', height: '32px', padding: 0 }}
                                onClick={() => setDeleteMachine(id)}
                            >
                                <FontAwesomeIcon icon={faTrash} />
                            </Button>
                        )}
                    </div>
                </td>
            </tr>
        </Fragment>
    );
};

MachineItem.propTypes = {
    machine: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        model: PropTypes.string,
        serial_number: PropTypes.string,
        status: PropTypes.string,
        operator: PropTypes.shape({
            id: PropTypes.number,
            first_name: PropTypes.string,
            last_name: PropTypes.string
        }),
        firm: PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string
        })
    }).isRequired,
    number: PropTypes.number.isRequired,
    setDeleteMachineId: PropTypes.func.isRequired,
    setUpdateMachineId: PropTypes.func.isRequired
};

export default connect(null, {setDeleteMachineId, setUpdateMachineId})(MachineItem); 